import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { StatisticTimeRange } from '../Enums/StatisticTimeRange.enum';

import { StatisticsSalesVolumeByCostCenterColumn } from './StatisticsSalesVolumeByCostCenterColumn.entity';

export class StatisticSalesVoumeByCostCenter<T extends EMode = EMode.entity> {
  /** Alias: start */
  start?: string;
  /** Alias: end */
  end?: string;
  /** Alias: timeSpanUnit */
  timeSpanUnit?: StatisticTimeRange;
  /** Alias: columnCount */
  columnCount?: number;
  /** Alias: columns */
  columns?: StatisticsSalesVolumeByCostCenterColumn<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<StatisticSalesVoumeByCostCenter> = {
  start: {
    alias: 'start',
  },
  end: {
    alias: 'end',
  },
  timeSpanUnit: {
    alias: 'timeSpanUnit',
  },
  columnCount: {
    alias: 'columnCount',
  },
  columns: {
    alias: 'columns',
    entity: Entities.statisticsSalesVolumeByCostCenterColumn,
  },
  __typename: {
    alias: '__typename',
  },
};

export const statisticSalesVoumeByCostCenterEntityDefinition: EntitiyDefinition<StatisticSalesVoumeByCostCenter> =
  {
    local: {},
    remote: {
      queryName: 'statisticSalesAmountByCostCenter',
      fragmentName: 'StatisticSalesVoumeByCostCenter',
      withPaginationWrapper: false,
      params: [
        { name: 'rangeType', type: 'StatisticTimeRange!' },
        { name: 'rangeStart', type: 'Date!' },
        { name: 'rangeEnd', type: 'Date' },
        { name: 'onlyRaInvoices', type: 'Boolean' },
        { name: 'customerCode', type: 'Int' },
        { name: 'useDeliveryPeriod', type: 'Boolean' },
      ],
    },
    fieldDefinitions: fields,
  };
